import React, { useState } from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import { LuMapPin } from "react-icons/lu";
import { FiPhone } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { useMediaQuery } from 'react-responsive';
import useFormvalidation from '../../validations/FormValidation'
import { ContactFormRules } from "../../validations/FormValidationRules";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaRegCalendar } from "react-icons/fa";
import Apis from '../../services/Apis'
import ContactForm from './ContactForm';


const Contact = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });


    return (
        <div className='contact-section' id="contact-section" style={{
            backgroundImage: `url(${isMobile ? "/mcontactusbg.png" : "/contactusbg.png"})`,
            // minHeight: "100dvh",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundColor: "#48025C9C",
            backgroundBlendMode: "multiply",
        }}>
            <Container className={`${isMobile ? 'mb-5' : ''}`}>
                <Row className='w-100'>
                    {isMobile ? <h3 className='px-5 mt-5 mb-1'>Contact Us</h3> : <h3 className='px-3 mb-5 mt-5'>Contact Us</h3>}
                    <Col lg={6} md={12} xs={12} style={{ marginBottom: isMobile ? '12%' : '', padding: isMobile ? '10% 0% 10% 14%' : '' }}>
                        <div>
                            
                            <ContactForm />
                            {/* <Row className={`${!isMobile ? 'mb-4' : ''}`} style={{ paddingRight : isMobile ? '20%' : ''}}> 
                                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                                    <Form.Control type="text" placeholder="Name" name="name" onChange={handleChange} value={values.name}/>
                                    <span className='error mt-3'>{errors.hasOwnProperty('name') && 
                                        <><AiOutlineExclamationCircle className="error-icon" style={{marginRight : '6px'}}/>{errors.name} </>} 
                                    </span>    
                                </Col>
                                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                                    <Form.Control type="email" placeholder="Email" name="email" onChange={handleChange} value={values.email} />
                                    <span className='error mt-3'>{errors.hasOwnProperty('email') && 
                                        <><AiOutlineExclamationCircle className="error-icon" style={{marginRight : '6px'}}/>{errors.email} </>} 
                                    </span>  
                                </Col>
                            </Row>
                            <Row style={{ paddingRight : isMobile ? '20%' : ''}}>
                                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                                    <Form.Control type="text" placeholder="Phone Number" name="phone" onChange={handleChange} value={values.phone}/>
                                    <span className='error mt-3'>{errors.hasOwnProperty('phone') && 
                                        <><AiOutlineExclamationCircle className="error-icon" style={{marginRight : '6px'}}/>{errors.phone} </>} 
                                    </span>  
                                </Col>
                                <Col lg={6} md={12} xs={12}>
                                    <div className='datepicker-container'>
                                        <DatePicker selected={date ? new Date(date) : null} onChange={handleDate} className='custom-datepicker' placeholderText="Select Date" />
                                        <FaRegCalendar className="calendar-icon" />
                                    </div>
                                    <span className='error mt-3'>{errors.hasOwnProperty('message') && 
                                        <><AiOutlineExclamationCircle className="error-icon" style={{marginRight : '6px'}}/>{errors.message} </>} 
                                    </span>  
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mt-4' : 'mt-5'}`}>
                                <Col>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                    <label class="form-check-label" htmlFor="flexCheckChecked" >
                                    I authorize representatives of IRA Aspiration to Call, SMS, Email or WhatsApp me about its products and offers. This consent overrides any registration for DNC/NDNC.
                                    </label>
                                </div>
                                </Col>
                            </Row>
                            <button type="submit" className='common-btn schedule-button mt-3' onClick={handleSubmit}>Schedule a Visit</button>
                            <ToastContainer /> */}

                        </div>

                    </Col>
                    <Col lg={6} md={12} xs={12} style={{ paddingLeft: '6%' }}>
                        <div className='d-flex'>
                            <div className='contact-icon'>
                                <button>
                                    <LuMapPin size={isMobile ? 20 : 25} />
                                </button>
                            </div>
                            <div className='contact-address'>
                                <p>Location:</p>

                                <span>IRA Realty Tech Pvt.Ltd, H.No: 4-49/2</span><br />
                                <span className='s2'>Besides Anvaya Conventions Rd,</span><br />
                                <span className='s2'>Financial District, Vattinaguapally,</span><br />
                                <span className='s2'>Hyderabad, Telangana 500032</span><br />
                            </div>
                        </div>
                        <div className='d-flex mt-3 w-100'>
                            <div className='d-flex mt-5 w-100'>

                                {/* Phone */}
                                <a
                                    href="tel:+919121777777"
                                    className='d-flex text-decoration-none text-white contact-icon'
                                    style={{ marginRight: '5%' }}
                                >
                                    <div className=''>
                                        <button>
                                            <FiPhone size={isMobile ? 20 : 25} />
                                        </button>
                                    </div>

                                    <div className='contact-address'>
                                        <span>Call Us:</span><br />
                                        <span>+91 9121777777</span>
                                    </div>
                                </a>

                                {/* Email */}
                                <a
                                    href="mailto:info@irarealty.in"
                                    className='d-flex text-decoration-none text-white contact-icon'
                                >
                                    <div className='contact-icon'>
                                        <button>
                                            <HiOutlineMail size={isMobile ? 20 : 25} />
                                        </button>
                                    </div>

                                    <div className='contact-address'>
                                        <span>Email:</span><br />
                                        <span>info@irarealty.in</span>
                                    </div>
                                </a>

                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Contact
